// extracted by mini-css-extract-plugin
module.exports = {"providers":"about_providers__Xyl9s","link":"about_link__2LEDc"};